import { t } from "i18next";
import * as z from "zod";

/**
 * Schéma du formulaire d'édition d'une clé de configuration système
 * (`PUT /SystemConfigs/{key}`, guide §6.8).
 * Factory mémoïsée au niveau composant sur la langue courante.
 */
export const createSystemConfigSchema = () =>
  z.object({
    value: z.string().trim().min(1, { message: t("requiredFieldError") }),
    description: z.string().trim().or(z.literal("")).optional(),
  });

export type SystemConfigFormValues = z.infer<
  ReturnType<typeof createSystemConfigSchema>
>;
